export enum BusinessActivity {
  TechnologyServices = 'Technology Services/Technology Consulting/SaaS',
  ResearchAndAnalyticsServices = 'Research and Analytics Services',
  Manufacturing = 'Manufacturing',
  GoodsExport = 'Goods Export',
  MarketingAndAdvertising = 'Marketing and Advertising',
  SoftwareServices = 'Software Services',
  Other = 'Other',
}
